module.exports = __webpack_public_path__ + "static/media/nav-icon1.4ecab4be.svg";